const twoWeeks = 14 * 24 * 60 * 60 * 1000;

export const LOCAL_STORAGE_KEY = `quiz.local`;
export const QUIZ_NAVIGATION_LOCAL_STORAGE_KEY = `quiz.nav`;
export const QUIZ_EXPIRY_LOCAL_STORAGE_KEY = `quiz.expiry`;
export const QUIZ_RESET_TTL = twoWeeks;

export const getQuizLocalStorageExpiry = (ttl: number) =>
  new Date(Date.now() + ttl).toISOString();

export const isQuizLocalStorageExpired = (expiry: string | null) => {
  if (expiry === null) {
    // Fallback - set the expiry date if it doesn't exist
    // This would be the case for users who have existing quiz local storage data from prior to rolling out this FE quiz reset.
    // A week after this initial, we can update this logic to simply clear local storage if expiry is null. Those users have not returned before the reset TTL and should start with empty quiz local storage.
    window.localStorage.setItem(
      QUIZ_EXPIRY_LOCAL_STORAGE_KEY,
      getQuizLocalStorageExpiry(QUIZ_RESET_TTL)
    );
    return false;
  }

  const now = new Date();
  const isExpired = new Date(JSON.parse(expiry)) < now;
  return isExpired;
};

export const clearQuizLocalStorage = () => {
  if (window.localStorage.getItem(LOCAL_STORAGE_KEY) !== null) {
    window.localStorage.removeItem(LOCAL_STORAGE_KEY);
  }
  if (window.localStorage.getItem(QUIZ_EXPIRY_LOCAL_STORAGE_KEY) !== null) {
    window.localStorage.removeItem(QUIZ_EXPIRY_LOCAL_STORAGE_KEY);
  }
  if (window.localStorage.getItem(QUIZ_NAVIGATION_LOCAL_STORAGE_KEY) !== null) {
    window.localStorage.removeItem(QUIZ_NAVIGATION_LOCAL_STORAGE_KEY);
  }
};
